import { throttle } from 'lodash-es';
import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { useMatchMedia } from '@xing-com/crate-hooks-use-match-media';
import { NoSSR } from '@xing-com/crate-utils-no-ssr';
import { mediaXWide } from '@xing-com/layout-tokens';

import { useAdRefresh } from '../../hooks';

import { DisplayAdProfileHalfpageSmall } from './halfpage-sticky-ad';

const OverflowContainer = styled.div`
  overflow-x: clip;
`;

const Wrapper = styled.div`
  width: 1030px;
  margin: 0 auto;
  position: relative;
`;

const AdContainer = styled.div<{ $isFixed: boolean }>`
  position: absolute;
  width: 160px;
  height: 600px;
  left: 100%;
  top: 290px;

  ${({ $isFixed }) =>
    $isFixed &&
    css`
      position: fixed;
      left: auto;
      top: 85px;
      margin-left: 1030px;
    `}
`;

export const DisplayAdProfileHalfpageSlotSmall: React.FC = () => {
  const isBigScreen = useMatchMedia(`${mediaXWide} and (max-width: 1700px)`);
  const [isFixed, setIsFixed] = useState(false);

  const { refreshDesktop } = useAdRefresh({
    isSmallScreen: !isBigScreen,
    slots: {
      mobile: '',
      desktop: 'halfpage',
    },
  });

  const setStickyPosition = (): void => {
    const topPosition = document.body.getBoundingClientRect().top;

    // Consider sticky navbar height
    setIsFixed(Math.abs(topPosition) >= 287);
  };

  useEffect(() => {
    const stickyCbThrottled = throttle(setStickyPosition, 100);
    window.addEventListener('scroll', stickyCbThrottled);

    return () => {
      window.removeEventListener('scroll', stickyCbThrottled);
    };
  }, []);

  if (!isBigScreen) {
    return null;
  }

  return (
    <OverflowContainer>
      <Wrapper>
        <NoSSR>
          <AdContainer $isFixed={isFixed}>
            <DisplayAdProfileHalfpageSmall refresh={refreshDesktop} />
          </AdContainer>
        </NoSSR>
      </Wrapper>
    </OverflowContainer>
  );
};
